import { TeamListProvider } from 'contexts/team-list.context';
import React from 'react';
import { Outlet } from 'react-router-dom';

const TeamListLayout = () => {
  return (
    <TeamListProvider>
      <Outlet />
    </TeamListProvider>
  );
};

export default TeamListLayout;
